import { render, staticRenderFns } from "./ComplianceWidget.vue?vue&type=template&id=01c396d0&scoped=true&lang=pug"
import script from "./ComplianceWidget.vue?vue&type=script&lang=ts"
export * from "./ComplianceWidget.vue?vue&type=script&lang=ts"
import style0 from "./ComplianceWidget.vue?vue&type=style&index=0&id=01c396d0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c396d0",
  null
  
)

/* custom blocks */
import block0 from "./ComplianceWidget.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FCompliance%2FComplianceWidgets%2FComplianceWidget.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports